<template>
  <div>
    <v-btn
      :loading="loading"
      class="mx-2"
      fab
      dark
      small
      color="primary"
      @click="loadGroupes()"
    >
      <v-icon dark>
        mdi-cached
      </v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  data() {
    return {
      groupes: [],
      loading: false,
    };
  },
  props: {
    projet: {
      required: true,
    },
  },

  methods: {
    loadGroupes() {
      // console.log("loadGroupes", this.projet);
      let self = this;
      self.loading = true;
      self.$firebase
        .firestore()
        .collection("groupes")
        .where("projectList", "array-contains", self.projet.id)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var groupe = doc.data();
            groupe.id = doc.id;
            self.groupes.push(groupe);
          });
          self.loading = false;
          self.updateProjet(self.groupes.length);
          self.$emit("updateProjet");
        });
    },

    updateProjet(nombre) {
      let self = this;
      var ref = self.$firebase
        .firestore()
        .collection("projets")
        .doc(self.projet.id);

      ref.set(
        {
          nbreGroupe: nombre,
          dateStatGroupe: self.$moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        { merge: true }
      );
    },
  },
};
</script>

<style scoped></style>
